import { TableSettings } from "../../../../tableSettings";

export const adjustBalanceTable: TableSettings = {
  tableVersion: 10049,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '300px',
  flexResizer: true,

columns: [
  {
    Header: '',
    accessor: 'indicator',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 3,
  },
  {
    Header: 'Id',
    accessor: 'id',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 7,
  },
  {
    Header: 'Date',
    accessor: 'invoiceDate',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },
  {
    Header: 'Account #',
    accessor: 'invoiceNo',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 11,
  },
  {
    Header: 'Head Inv.Amount',
    accessor: 'hdInvAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },
  {
    Header: 'Head Duty Amount',
    accessor: 'hdDutyAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },
  {
    Header: 'Head Paid Amount',
    accessor: 'hdPaidAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },

  {
    Header: 'Head Duty Paid Amount',
    accessor: 'hdDutyPaidAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 11,
  },
  {
    Header: 'Detail Inv.Amount',
    accessor: 'dtInvAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },
  {
    Header: 'Detail Duty Amount',
    accessor: 'dtDutyAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },
  {
    Header: 'Actual Paid Amount',
    accessor: 'rPaidAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 8,
  },

  {
    Header: 'Actual Duty Paid Amount',
    accessor: 'rDutyPaidAmt',
    resizable: true,
    sortable: false,
    visible: true,
    initialWidthPercentage: 11,
  },
  {
    Header: '',
    accessor: 'scroll',
    resizable: false,
    sortable: false,
    visible: true,
    initialWidthPercentage: 2,
  },
]
};

